import { PointIcon } from '../../icons/point-icon'

const PointRightContent = ({ points }: { points: number }) => {
  if (!points) {
    return null
  }

  return (
    <div className="flex items-center gap-0.5">
      <p className="text-[15px] font-bold text-primary">+ {points}</p>
      <span className="-mb-0.5 flex">
        <PointIcon size={16} />
      </span>
    </div>
  )
}

export default PointRightContent
